import "@/App.css";
import {
  Navigation,
  HeroSection,
  ProblemSection,
  FeaturesSection,
  SupportedDocuments,
  HowItWorks,
  DashboardPreview,
  PricingSection,
  DeveloperSection,
  CTASection,
  Footer,
} from "./components/landing";

function App() {
  return (
    <div className="min-h-screen bg-white">
      {/* Noise overlay for texture */}
      <div className="noise-overlay" />
      
      {/* Navigation */}
      <Navigation />
      
      {/* Main content */}
      <main>
        {/* Hero Section */}
        <HeroSection />
        
        {/* Problem Section */}
        <ProblemSection />
        
        {/* Features Section */}
        <FeaturesSection />
        
        {/* Supported Documents */}
        <SupportedDocuments />
        
        {/* How It Works */}
        <HowItWorks />
        
        {/* Dashboard Preview */}
        <DashboardPreview />
        
        {/* Pricing Section */}
        <PricingSection />
        
        {/* Developer Section */}
        <DeveloperSection />
        
        {/* Final CTA */}
        <CTASection />
      </main>
      
      {/* Footer */}
      <Footer />
    </div>
  );
}

export default App;
